import React, { Component, Fragment } from 'react'
import {TREE, DAYS} from "./tree"
import auth from "./dashboard/auth"
import SignIn from './dashboard/SignIn';
import {SignOutDirect, SignOut} from './dashboard/SignOut';
import mailSender from "./mailer";
import generateGUID from './dashboard/ID_Generator';



let d = new Date();
let year = d.getFullYear();
let date = d.getDate();
let day = d.getDay();
let month = d.getMonth();
let count = 0; // in order to increment the date

class Calendar extends Component {

    constructor(props){
        super(props);
        
        this.state = {

            time: null,
            selectedDay: -1,
            selectedSlot: -1,
            name: "",
            email:"",
            status: null,
            sortedTree: sortArray(TREE),
            sortedDays: sortArray(DAYS),
            finalDate: "",
            isLoaded : false,
            isLoggedin: true,
            loginMessage: null
        };
    }

    showTimes(index, finalDate){
        if(index < 0) return "";
        
        var cl = this;

        this.setState({
            finalDate
        })
        

        let myPromises = cl.state.sortedTree[index].map((item, i)=>{

            let time = cl.state.sortedTree[index][i]["time"];
            var docRef = auth.firestore().collection(cl.state.sortedDays[index] ).doc(time);
            return docRef.get();
            
        })

        Promise.all(myPromises).then((value)=>{
          
            this.setState({
                time: (<div>
                    {
                        cl.state.sortedTree[index].map((item, i)=>{

                            //Home many people registered
                            let registered = value[i].data()[finalDate] ? value[i].data()[finalDate].length : 0;
                        
                            return (
                                <React.Fragment key={i}>
                                    <input className="checkbox-budget" disabled={(item.size-registered) <= 0} type="radio" name="budget" id={item.time} 
                                    onChange={
                                        ()=>{cl.selectSlot(i);}
                                    }
                                    />
                                    <label className="for-checkbox-budget" htmlFor={item.time}>
                                    <span>{item.title}</span>
                                    <br />
                                    <small>{item.time}</small><br/><br/>
                                    <small style={{fontSize:14, fontWeight:300, marginTop:20}}> Noch  ({item.size-registered}) Plätze  frei</small>
                                    
                                    </label>
                                </React.Fragment>
                            )
                
                            
                        })
                        
                    }
                </div>)
            })
        })
    }

    selectDay(index){
        this.setState({
            selectedDay: index
        })
    }

    selectSlot(index){
        this.setState({
            selectedSlot: index
        })
    }

    generateID(){

        let myDate = new Date();
        myDate.setDate(myDate.getDate() + this.state.selectedDay)


        return myDate.getDate() +"-" + (myDate.getMonth()+1) + "-" + myDate.getFullYear();
    }

    submit(e){
        e.preventDefault();
        let CLASS = this;

        if(this.state.name == "" || this.state.email == "" || this.state.selectedDay == -1 || this.state.selectedSlot == -1){
           
            CLASS.setState({
                status: <div className="alert alert-danger alert-dismissible fade show" role="alert">
                Alle Formulare müssen ausgefüllt werden!
                <button type="button" className="close" onClick={()=>{
                    CLASS.setState({ status: null})
                }} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            })

            return;
        }


        //Save to database
        let time = CLASS.state.sortedTree[CLASS.state.selectedDay][CLASS.state.selectedSlot]["time"];
        let id = generateGUID();

        var docRef = auth.firestore().collection(CLASS.state.sortedDays[CLASS.state.selectedDay] ).doc(time);

        docRef.get().then(function(doc) {
            if (doc.exists) {
                

                let oldData = doc.data()[CLASS.generateID()] ? doc.data()[CLASS.generateID()] : [];
                
                
                if(oldData.length < CLASS.state.sortedTree[CLASS.state.selectedDay][CLASS.state.selectedSlot]["size"]){
                    // now update
                    docRef.update({
                        [CLASS.generateID()]: [
                            ...oldData, // prevoius data
                            {
                                name: CLASS.state.name,
                                email: CLASS.state.email,
                                date: new Date(),
                                id
                                
                            }
                        ]
              
                        
                    })
                    .then(function(ref) {

                        //Send email
                        mailSender(
                            CLASS.state.email,
                            CLASS.state.name,
                            CLASS.state.finalDate,
                            CLASS.state.sortedDays[CLASS.state.selectedDay],
                            CLASS.state.sortedTree[CLASS.state.selectedDay][CLASS.state.selectedSlot]['time'],
                            CLASS.state.sortedTree[CLASS.state.selectedDay][CLASS.state.selectedSlot]['title'],
                            id
                        );

                        //Refresh the slot list
                        CLASS.showTimes(CLASS.state.selectedDay, CLASS.state.finalDate);
    
                        //Success message
                        CLASS.setState({
                            status: <div className="alert alert-success alert-dismissible fade show" role="alert">
                            <strong>Hallo {CLASS.state.name}!</strong> Sie haben erfolgreich gebucht.
                            <button type="button" className="close" onClick={()=>{
                                CLASS.setState({ status: null})
                            }} aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>,
                          name: "",
                          email: ""
            
                        });
            
                    })
                    .catch(function(error) {
                        CLASS.setState({
                            status: <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            <strong>Hallo {CLASS.state.name}!</strong> Sie haben diesen Slot bereits gebucht.
                            <button type="button" className="close" onClick={()=>{
                                CLASS.setState({ status: null})
                            }} aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        })
                    });
                }else{
                    //Limit over message
                    CLASS.setState({
                        status: <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>Hallo {CLASS.state.name}!</strong>Dieser Slot ist ausgebucht. Bitte aktualisieren Sie die Website und probieren Sie andere Slots aus
                        <button type="button" className="close" onClick={()=>{
                            CLASS.setState({ status: null})
                        }} aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    })
                }

                



            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });


    }



    componentDidMount(){

        const CL = this;
        auth.firestore().collection("Samstag").doc("10:30-11:45").get().then(function(doc) {
            if (doc.exists) {
                console.log("Document data:", doc.data());
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });


        //Perform auth
        auth.auth().onAuthStateChanged((user) => {
            if (user) {
            
              var uid = user.uid;
              console.log("user logged in", uid)

              CL.setState({
                isLoggedin: true
                }); 
              
            } else {
                CL.setState({
                    isLoggedin: false
                });
            }


            // checking finished
            CL.setState({
                isLoaded: true
            });
          });
    }


    render() {
        if(!this.state.isLoaded) {
            return <div></div>;
        }


        return (
        <div className="section over-hide z-bigger">
            <input style={{display:"none"}} className="checkbox" type="checkbox" name="general" id="general" checked/>
            <label style={{display:"none"}} className="for-checkbox" htmlFor="general"></label>
            <div className="background-color"></div>
            <div className="section over-hide z-bigger">
                <div className="container pb-5">
                    <div className="row justify-content-center pb-5">
                        <div className="col-12 pt-5">
                            <p className="mb-4 pb-2">Wähle den Tag</p>
                        </div>
                        <div className="col-12 pb-5">
                        
                        {this.state.sortedTree.map((item, index)=>{
                            let newDate = new Date();
                            newDate.setDate(date + index);
            
                            let finalDate = newDate.getDate() +"-"+ (newDate.getMonth() + 1 ) +"-"+ newDate.getFullYear();
                            

                            let currentDay = sortArray(DAYS)[index];
                            return (
                                <React.Fragment key={index}>
                                    <input className="checkbox-tools" type="radio" name="tools" id={currentDay} onChange={(e)=>{
                                    
                                        this.showTimes(index, finalDate)
                                        this.selectDay(index);
                                    }}/>
                                    <label className="for-checkbox-tools" htmlFor={currentDay}>
                                        {currentDay}
                                        <br/>
                                        <small>{finalDate}</small>
                                        
                                    </label> 
                                </React.Fragment>
                            )
                        })}
                            
                        </div>
                        <div className="col-12 pt-1">
                              {(this.state.finalDate != "") ? <p className="mb-4 pb-2">Wähle die Zeit</p> : ""}
                        </div>
                        <div className="col-xl-10">
                            {this.state.time}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8 pt-1">
                            {this.state.status && this.state.status}
                            {(this.state.finalDate != "") ?
                            
                            <form className="submissionForm mt-1">
                                <input type="text" placeholder="Name" value={this.state.name} onChange={
                                    (e) => {
                                        this.setState({name:e.target.value})
                                    }
                                }/>
                                <input type="email" placeholder="Email" value={this.state.email} onChange={
                                    (e) => {
                                        this.setState({email:e.target.value})
                                    }
                                } required/>
                                    <button onClick={(e)=>{this.submit(e)}}>Senden</button>
                            </form>
                            
                            : ""}
                            
                        </div>
                    </div>
                </div>	
            </div>
        </div>

        )

        
    }
}


const sortArray = (arr)=>{

    let sortedArr = [];
    let j = 0;

    for(let i = day; i < arr.length; i++){
        sortedArr[j] = arr[i];
        j++;
    }

    for(let i = 0; i < day; i++){
        sortedArr[j] = arr[i];
        j++;
    }

    return sortedArr;
}

export default Calendar
